import { createContext } from "react";

export const ComponentContext = createContext<string | undefined>(undefined);
